"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchResponse = fetchResponse;
exports.buildRequestPayload = buildRequestPayload;
exports.getWatchList = getWatchList;
exports.getItemVariation = getItemVariation;
exports.addToWatch = addToWatch;
exports.removeFromWatch = removeFromWatch;
const constants_1 = require("../constants");
function fetchResponse(data_1) {
    return __awaiter(this, arguments, void 0, function* (data, endpointAction = '') {
        const requestData = buildRequestPayload(data);
        const url = `https://${data.hostname}${constants_1.WATCH_API_PATH}${endpointAction}`;
        try {
            const response = yield fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    srt: data.csrfToken,
                },
                body: JSON.stringify(requestData),
            });
            const responseData = yield response.json();
            return responseData;
        }
        catch (error) {
            let errorMessage = '';
            if (error instanceof Error) {
                errorMessage = error.message;
            }
            return {
                status: 'ERROR',
                message: '',
                error: errorMessage,
            };
        }
    });
}
function buildRequestPayload(data) {
    const { itemData, listName = '', trackingData } = data;
    let { listId = '' } = data;
    const { itemId, variationId } = itemData;
    const itemInfo = [{ itemId, variationId }];
    if (listId === '' && listName === '') {
        listId = 'WATCH_LIST';
    }
    const trackingInfo = {
        linkId: trackingData.linkId || '',
        moduleId: (trackingData === null || trackingData === void 0 ? void 0 : trackingData.moduleId) || '',
        pageId: (trackingData === null || trackingData === void 0 ? void 0 : trackingData.pageId) || '',
    };
    return Object.assign(Object.assign(Object.assign({ itemInfo }, (listId ? { listId } : {})), (listName ? { listName } : {})), { trackingInfo });
}
const fetchWatchLists = (settings) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `https://${settings.hostname}${constants_1.WATCH_LISTS_API_PATH}`;
    try {
        const response = yield fetch(url, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const responseData = yield response.json();
        return responseData;
    }
    catch (error) {
        let errorMessage = '';
        if (error instanceof Error) {
            errorMessage = error.message;
        }
        return {
            status: 'ERROR',
            message: '',
            error: errorMessage,
            userWatchLists: [],
        };
    }
});
const fetchItemVariation = (settings, itemId) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `https://${settings.hostname}${constants_1.ITEM_VARIATION_API_PATH}?listingId=${itemId}`;
    try {
        const response = yield fetch(url, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const responseData = yield response.json();
        return responseData;
    }
    catch (error) {
        let errorMessage = '';
        if (error instanceof Error) {
            errorMessage = error.message;
        }
        return {
            status: 'ERROR',
            message: errorMessage,
            error: error instanceof Error ? error.message : String(error),
        };
    }
});
function getItemVariation(settings, itemId) {
    return fetchItemVariation(settings, itemId);
}
function getWatchList(settings) {
    return fetchWatchLists(settings);
}
function addToWatch(data) {
    return fetchResponse(data, constants_1.WATCH_API_ENDPOINT.ADD);
}
function removeFromWatch(data) {
    return __awaiter(this, void 0, void 0, function* () {
        return fetchResponse(data, constants_1.WATCH_API_ENDPOINT.REMOVE);
    });
}
